"use client";

import { useEffect } from "react";
import Link from "next/link";

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    void (async () => {
      try {
        const { reportError } = await import("@/lib/flare");
        await reportError(error, { kind: "client", digest: error.digest });
      } catch {
        // the page is already broken; a failed report must not make it worse
      }
    })();
  }, [error]);

  return (
    <main className="error-page">
      <div className="card error-card">
        <div className="cut error-inner">
          <h1 className="wavy">Something tore.</h1>
          <p>Nothing was changed. Trying again usually works.</p>
          <div className="error-actions">
            <button type="button" className="btn" onClick={reset}>Try again</button>
            <Link className="btn btn-quiet" href="/">Back home</Link>
          </div>
          {error.digest && <p className="error-digest">{error.digest}</p>}
        </div>
      </div>
    </main>
  );
}
